export default __webpack_public_path__ + "static/media/mail.767eebd3.svg";